import { getSessionId } from "../../authStorage";

export default () => `screen:${getSessionId()}`;
